<template>
  <div class="w-100 text-center my-2">
    <span>
      {{ statusText }}
    </span>
    <i
      :id="popoverId"
      class="fas fa-info-circle"
      style="cursor: pointer"
    />

    <d-popover
      :key="popoverRenderKey"
      :target="popoverId"
      placement="auto"
      :triggers="['hover']"
    >
      <template slot="title"> {{ title }} </template>

      <template>
        <ul class="mb-0 pl-0 words" style="list-style-type: none">
          <li
            v-for="(item, index) in placedWordsList"
            :key="index + 'placed-word'"
          >
            ✅ {{ item }}
          </li>

          <li
            v-for="(item, index) in unplacedWordsList"
            :key="index + 'unplaced-word'"
          >
            ❌ {{ item }}
          </li>
        </ul>
      </template>
    </d-popover>
  </div>
</template>

<script>
import { getLength, getWordsStatus } from '_utils';

export default {
  name: 'GameStatusAndPopover',
  props: {
    wordsList: {
      type: Array,
      required: true,
    },
    placedWords: {
      type: Array,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    popoverId() {
      return `popover-info-${this.index + 1}`;
    },
    popoverRenderKey() {
      return [
        this.popoverId,
        this.placedWordsList.join('|'),
        this.unplacedWordsList.join('|'),
      ].join('::');
    },
    placedCount() {
      return this.placedWords.length;
    },
    totalCount() {
      return getLength(this.wordsList);
    },
    statusText() {
      return this.$t('shared.gameStatus.summary', {
        placed: this.placedCount,
        total: this.totalCount,
        description: this.description,
      });
    },
    wordsStatus() {
      return getWordsStatus(
        this.wordsList,
        this.placedWords,
      );
    },
    placedWordsList() {
      return this.wordsStatus.placed;
    },
    unplacedWordsList() {
      return this.wordsStatus.unplaced;
    },
  },
};
</script>

<style lang="scss" scoped>
.words {
  font-size: 14px;
}
</style>
